import STACK_CONFIG from './config/BuildStack.json'

export const styles = theme => ({
    button: {
        margin: '8px',
    }, root: {
        display: "flex",
        flexWrap: "wrap"
    }, margin: {
        margin: '8px'
    },
    formControl: {
        minWidth: '194px'
    },
    marginLeft :{
        marginLeft: '8px'
    },withoutLabel: {
        marginTop: '8px' * 3
    }, textField: {
        flexBasis: 200
    }, topBarButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
    }, toggleMapButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
        width: '817px'
    }, plainWhiteButton: {
        color: '#000',
        borderWidth: 'thin',
        backgroundColor: '#ffffff',
        width: '200px'
    }, clearPolygonButton: {
        color: '#000',
        borderWidth: 'thin',
        '&:hover': {
          backgroundColor: '#EE5353',
          // borderColor: '#B2B2B2',
        },
        // backgroundColor: '#EE5353',
    }, mapContainer: {
        backgroundColor: '#ebf0f4',
        borderStyle: 'solid',
        borderColor:'#4589b6',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }, metOptionsContainer: {
        width: '815px',
    }, toggleAdvancedOptionsButton: {
        // color: '#212121',
        // borderColor: '#878787',
        // borderWidth: 'thin',
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: '#EDEDED',
          borderColor: '#B2B2B2',
        },
        width: '817px'
    }
    , advancedOptionsContainer: {
        // backgroundColor: '#EDEDED',
        borderBottomStyle: 'solid',
        borderLeftStyle: 'solid',
        borderRightStyle: 'solid',
        borderColor:'#B2B2B2',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }
});

export const stackInit = {
    'source' : {
        stackName: "",
        emissionType: "",
        latUTMx: null,
        lonUTMy: null,
        height: null,
        diameter: null,
        exitTemperature:null,
        exitVelocity:null,
        areaX:null,
        areaY:null,
        anga:null,
        emisNO2: 0,
        emisNO: 0,
        emisSO2: 0,
        emisCO: 0,
        emisANO3J: 0,
        emisASO4J: 0,
        emisAECJ: 0,
        emisAORGPAJ: 0,
        emisANH4J: 0,
        emisACLJ: 0,
        emisA25J: 0,
        emisH2O2: 0
    }
}

export const advancedOptions = {
    //input
    staticVar: true,
    conc_min: 0,
    trel: 0,
    landuse: 'CULTIVATED',
    pr_type: 'METFILE',

    //output
    lout_met: false,
    tout_met: -999999,
    lout_3D: false,
    lout_2D: false,
    lformat: false,
    batteryoption: 'HFHCL',
    percent_HF: 30,

    //domain
    zmax: 2500,
    vres: 250,
    z_dosage: 0,
    maxpuff: 20000,

    //Partical-Gas Options
    gas_deposition: 0,
    nsg: 1,
    psize: 2.5,
    pbounds: 2.5,
    subgroup: 1,

    //deposition
    dense_gas: false,
    group_deposition: false,
    total_deposition: false,
    group_dose: false,
    total_dose: false,
    decay_amp: 0,
    decay_min: 0,
    density: 1.2,

    //physics
    dynamic: true,
    t_avg: 0,
    cmin: 0,
    delmin: 0,
    wwtrop: 0.01,
    epstrop: 0.0004,
    sltrop: 10,
    uu_calm: 0.25,
    sl_calm: 1000,
    nzbl: 11,
    mgrd: 2,
    grdmin: 0,
    ensm_type: 'OPER',
    cmass: 1,
    uu_ensm: 0,
    sl_ensm: 100000,
    h_cnp: -1,
    zruf: 0.03,
    sl_haz: -999999,

    //boundary layer
    bl_type: 'OPER',
    zimin: 50,
    zimax: 1000,
    hconst: 0,
    hdiur: 50,
    albedo: 0.16,
    bowen: 0.6,
    cloud_cover: 0,

    //MCWIF
    lmc_ua: false,
    alpha_max: 1,
    alpha_min: 0.001,
    max_iter_ac: 200,
    ac_eps: 0.01,
    max_iter: 100,
    p_eps: 0.00001,
    zb:"50,150,385,675,845,1032,1467,1719,1996,2300,2634,3592,4503,6227,7444,9000,11000",
}

export function validateRequestBody(formInputs) {
    let mcError = false
    let mcErrorS = false
    let mcErrorStN = false
    let checkSource = true
    let mcErrorBatSrc = true
    let fire = false
    let runaway = false
    let mcParams = []

    if (formInputs['runOption']==="met"){
        checkSource = false
    }

    ////////////////////////
    //battery fire run option checks
    if (formInputs['runOption']==="battery" && formInputs['advancedOptions']['batteryoption'] === "HFHCL"){
        Object.keys(formInputs["source"])
            .forEach(key => {
                if (formInputs["source"][key]['stackName'].includes('fire') ){
                    fire = true
                }else if (formInputs["source"][key]['stackName'].includes('runaway') ){
                    runaway = true
                }})     
    } 
    
    //if 2 stacks one named fire and one named runaway then we good    
    if (fire && runaway && formInputs['advancedOptions']['batteryoption'] === "HFHCL"){
        mcErrorBatSrc = false
    } else if (formInputs['advancedOptions']['batteryoption'] === "DF")
        mcErrorBatSrc = false
        
    if (mcErrorBatSrc && formInputs['runOption'] === "battery"){
        if (!fire){
            return "for Battery Fire Simulation: one source must be named 'fire' for combustion simulation."
        } else if (!runaway){
            return "for Battery Fire Simulation: one source must be named 'runaway' for thermal runaway simulation."
        }        
    }

    ////////////////////////    

    if (checkSource){
        mcError = true

        Object.keys(formInputs["source"])
            .forEach(key => {
                if (!formInputs["source"][key]['stackName'] || !formInputs["source"][key]['emissionType']){
                    mcErrorS= true
                }else{
                    formInputs["source"][key]['emissionType']=formInputs["source"][key]['emissionType'].toUpperCase()
                    console.log(formInputs["source"][key]['emissionType'])

                    if (formInputs["source"][key]['emissionType']==='P' && (!formInputs["source"][key]['stackName'] || !formInputs["source"][key]['latUTMx'] || !formInputs["source"][key]['lonUTMy'] ||
                     !formInputs["source"][key]['height'] || !formInputs["source"][key]['diameter'] || !formInputs["source"][key]['exitTemperature'] ||
                     !formInputs["source"][key]['exitVelocity'])){
                        mcErrorS= true
                    }else if (formInputs["source"][key]['emissionType']==='A' && (!formInputs["source"][key]['stackName'] || !formInputs["source"][key]['latUTMx'] || !formInputs["source"][key]['lonUTMy'] ||
                     !formInputs["source"][key]['height'] || !formInputs["source"][key]['exitTemperature'] || !formInputs["source"][key]['exitVelocity'] || !formInputs["source"][key]['areaX'] ||
                     !formInputs["source"][key]['areaY'] || !formInputs["source"][key]['anga'])){
                        mcErrorS= true
                    }
                    if  (formInputs['scichemStackSourceLocationFile'] && formInputs['scichemStackSourceLocationFile']!=="NONE"){
                        mcErrorS= false
                    }
        }})

        Object.keys(formInputs["source"])
            .forEach(key => {
                let stkLat = Math.abs(parseFloat(formInputs["source"][key]['latUTMx'])- formInputs['latitude'])
                let stkLon = Math.abs(parseFloat(formInputs["source"][key]['lonUTMy'])- formInputs['longitude'])
                console.log(stkLat)
                console.log(stkLon)
                if (formInputs["source"][key]['stackName'].includes(' ') || formInputs["source"][key]['stackName'].includes('-') || formInputs["source"][key]['stackName'].includes('.')){
                    mcErrorStN = true
                }
        })

        STACK_CONFIG.stack['source'].forEach(item => {
            if (item['name'] === "Multiple Component Emissions"){
                item['values'].forEach(value => {
                    mcParams.push(value.value)
                })
            }
        })

        Object.keys(formInputs["source"])
            .forEach(key => {
                mcParams.forEach(mcEmission =>{
                    if (formInputs["source"][key][mcEmission] > 0 || (formInputs['scichemStackSourceLocationFile'] &&
                        formInputs['scichemStackSourceLocationFile']!=="NONE")){
                            mcError = false
                        }
                    if (formInputs["source"][key][mcEmission] ===""){
                        formInputs["source"][key][mcEmission]=0
                    }
                })
        })
    }

    let mcErrorHrly = false
    console.log(formInputs['hourlyEmissionsDataFile'])
    if (formInputs['hourlyEmissionsDataFile'] !== null && !formInputs['hourlyEmissionsDataFile'].endsWith('.emi') && formInputs['hourlyEmissionsDataFile'] !== "NONE"){
            mcErrorHrly=true
    }

    if (mcErrorStN){
        return "Source name must be alphanumeric with no spaces"
    }else if (mcErrorS){
        return "Please fill out the necessary source parameters"
    } else if (mcError){
        return "At least one Emission must be > 0"
    } else if (!formInputs['useDefaultMetCheck'] && !formInputs['wrfAndMMIF'] && (!formInputs['onsiteMeteorologicalDataFile'] ||
        formInputs['onsiteMeteorologicalDataFile']==="NONE") && (JSON.parse(formInputs['selectedSurfaceStation']).name === "today" ||
        JSON.parse(formInputs['selectedUpperAirStation']).name === "today" ) && (!formInputs['previousMet'] || formInputs['previousMet']==="NONE" )){
        return 'Please select a valid Meteorological option'
    } else if (!formInputs['latitude'] || !formInputs['longitude']){
        return 'Please provide project coordinates'
    } else if (!formInputs['modelDescription']){
        return 'Please provide a project description'
    } else if (formInputs['timeOption']==="YEAR" && !formInputs['runYear']){
        return 'Please provide a project run year'
    } else if (formInputs['timeOption']==="SL" && (!formInputs['sdate'] || !formInputs['runHours'])){
        return 'Please provide a project run time'
    } else if (formInputs['timeOption']==="SE" && (!formInputs['sdate'] || !formInputs['edate'])){
        return 'Please provide a project run time'
    } else if (!formInputs['dEW'] || !formInputs['dNS'] || !formInputs['spacing'] || !formInputs['dHeight']){
        return 'Please provide project domain parameters'
    } else if (!formInputs['pollutant'] && formInputs['runOption']!=="met" ){
        return 'Please select a pollutant'
    } else if ((formInputs['onsiteMeteorologicalDataFile'] && formInputs['onsiteMeteorologicalDataFile']!=="NONE") &&
                (!formInputs['osLat'] || !formInputs['osLon'] || !formInputs['osElev'] || !formInputs['os_pr_type'])){
        return 'Please provide more onsite station information'
    }else if (!formInputs['wrfAndMMIF'] && (formInputs['dEW']>46 || formInputs['dNS']>46)){
        return 'This grid is too large for NOAA station data, please use WRF/MMIF or reduce the domain to less than 46 km.'
    }else if (formInputs['wrfAndMMIF'] && (formInputs['dEW']<30 || formInputs['dNS']<30)){
        return 'This grid is too small for WRF data, please use NWS station data or increase the domain size to 50.'
    }else if ((formInputs['onsiteMeteorologicalDataFile'].endsWith('.txt') || formInputs['onsiteMeteorologicalDataFile'].endsWith('.dat')) && formInputs['onsiteMeteorologicalDataFile'] !== null){
        return 'Onsite file must end with ".txt" or ".dat"'
    }else if (mcErrorHrly){
        return 'Hourly emissions file must end with ".emi"'
    }
}

export function translateRequestBody(formInputs) {
    let requestBody = {
        "MODEL": formInputs["model"],
        "DESCRIPTION": formInputs["modelDescription"],
        "BLDG_FILE": formInputs["buildingLocationFile"],
        "FENCE_FILE": formInputs["fenceLineLocationFile"],
        "MMIF_CHECK": formInputs["wrfAndMMIF"],
        "POLLUTANT": formInputs["pollutant"],
        "CTM": formInputs["useCTM"],
        "ONSITE_FILE": formInputs["onsiteMeteorologicalDataFile"],
        "HOURLY_FILE": formInputs["hourlyEmissionsDataFile"],
        "ONSITE_LAT": formInputs["osLat"],
        "ONSITE_LON": formInputs["osLon"],
        "ONSITE_ELEV": formInputs["osElev"],
        "RUN_OPT": formInputs["runOption"],
        "TIME_OPT": formInputs["timeOption"],
        "TZONE": formInputs["timeZone"],
        "STATE": formInputs["stateACRONYM"],
        "SDATE": formInputs["sdate"],
        "EDATE": formInputs["edate"],
        "HOURS": formInputs["runHours"],
        "YEAR": formInputs["runYear"],
        "SFC_MET_OPT": formInputs["selectedSurfaceStation"],
        "STACK_NO": Object.keys(formInputs["source"]).length,
        "STK1": [],
        "EMIS": [],
        "STK_FILE": formInputs["scichemStackSourceLocationFile"],
        "UPA_MET_OPT": formInputs["selectedUpperAirStation"],
        "FIND_MET": formInputs["useDefaultMetCheck"],
        "SENSITIVE_REC": formInputs["sensitiveRecCheck"],
        "USRLAT": formInputs["latitude"],
        "USRLON": formInputs["longitude"],
        "DOMAIN_EW": formInputs["dEW"],
        "DOMAIN_NS": formInputs["dNS"],
        "DOMAIN_Z": formInputs["dHeight"],
        "DOMAIN_RES": formInputs["spacing"],
        "BUILDING_GEOJSON": formInputs["buildingGeojson"],
        "FENCELINE_GEOJSON": formInputs["fencelineGeojson"],
        "DRAWN_BUILDINGS": formInputs["drawnBuildings"],
        "DRAWN_FENCELINES": formInputs["drawnFencelines"],
        "PREVIOUSMET": formInputs["previousMet"],
        "os_pr_type": formInputs["os_pr_type"],
        "ADVANCEDOPTIONS" : formInputs['advancedOptions'],
    };

    Object.keys(formInputs["source"])
        .forEach(key => {
            requestBody["STK1"].push([
                formInputs["source"][key]['stackName'],
                formInputs["source"][key]['emissionType'],
                formInputs["source"][key]['latUTMx'],
                formInputs["source"][key]['lonUTMy'],
                formInputs["source"][key]['height'],
                formInputs["source"][key]['diameter'],
                formInputs["source"][key]['exitTemperature'],
                formInputs["source"][key]['exitVelocity'],
                formInputs["source"][key]['areaX'],
                formInputs["source"][key]['areaY'],
                formInputs["source"][key]['anga'],
            ]);
            requestBody["EMIS"].push([
                formInputs["source"][key]['emisNO2'],
                formInputs["source"][key]['emisNO'],
                formInputs["source"][key]['emisSO2'],
                formInputs["source"][key]['emisCO'],
                formInputs["source"][key]['emisANO3J'],
                formInputs["source"][key]['emisASO4J'],
                formInputs["source"][key]['emisAECJ'],
                formInputs["source"][key]['emisAORGPAJ'],
                formInputs["source"][key]['emisANH4J'],
                formInputs["source"][key]['emisACLJ'],
                formInputs["source"][key]['emisA25J'],
                formInputs["source"][key]['emisH2O2'],
            ])
    })

    return requestBody
}
